module.exports = __webpack_public_path__ + "static/media/creditCard-card.1eb011c5.svg";